import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {MedicalMorphologyModel} from '../medicalMorphology.model';
import {Injectable} from '@angular/core';
import {ConsultationConverter} from '../../../../consultation/consultation/api/model/converter/consultation.converter';
import {
    ConsultationSummaryConverter
} from '../../../../consultation/consultation/api/model/converter/consultationSummary.converter';
import {DateConverter} from '../../../../../common/converter/date.converter';
import {PermissionsConverter} from '../../../../../common/converter/permissions.converter';
import {PartnerSummaryConverter} from '../../../../../partner/common/api/converter/partnerSummary.converter';

@Injectable({
    providedIn: 'root'
})
export class MedicalMorphologyConverter extends HttpModelConverter<MedicalMorphologyModel> {

    constructor(private consultationSummaryConverter: ConsultationSummaryConverter) {
        super();
    }
    protected createInstance(): MedicalMorphologyModel {
        return new MedicalMorphologyModel();
    }

    protected enrichObject(result: MedicalMorphologyModel, src: MedicalMorphologyModel) {
        result.consultation = this.consultationSummaryConverter.convert(src?.consultation);
        result.date = new DateConverter().convert(src.date);
        result.permissions = new PermissionsConverter().convert(src.permissions);
        result.partner = new PartnerSummaryConverter().convert(src.partner);
    }

}
